var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.selectedDeposit && _vm.selectedDeposit.Sale
    ? _c(
        "w-modal",
        { attrs: { value: "" } },
        [
          _vm.showTicketRefundModal
            ? _c("app-ticket-refund-modal", {
                attrs: { "is-deposit": "", state: _vm.state },
                on: {
                  update: function ($event) {
                    return _vm.onSaved()
                  },
                  cancel: function ($event) {
                    return _vm.close()
                  },
                },
              })
            : _c("app-bank-edit", {
                attrs: { sale: _vm.selectedDeposit.Sale },
                on: {
                  "bank-saved": function ($event) {
                    return _vm.onSaved()
                  },
                  cancel: function ($event) {
                    return _vm.close()
                  },
                },
              }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }